<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        Accredited CPD Provider Report
        <v-spacer></v-spacer>

        <div class="ml-12">
          <download-excel
              :data="selected"
              :fields="export_fields"
              name="accreditedCPDProviderReport.xls"
              type="csv"
          >
            <v-btn
                class="teal white--text"
                color="primary"
                dark
                depressed
                small
            >
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>

      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filteredReports"
          :loading="loading"
          item-key="id"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field
                  v-model="accreditorValue"
                  label="Accreditor Name"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field
                  v-model="accreditationCodeValue"
                  label="Accreditation Code"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field
                  v-model="cpdPNameValue"
                  label="CPD Provider's Name"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePreset"
                  :items="dateRangePresets"
                  item-text="text"
                  item-value="value"
                  clearable
                  label="Quick Range"
              ></v-select>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangeYear"
                  :items="dateRangeYears"
                  clearable
                  label="Year"
              ></v-select>
            </v-flex>
            <v-flex v-if="dateRangePreset && dateRangePreset !== 'yearly'" class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePeriod"
                  :items="getPresetPeriodOptions(dateRangePreset)"
                  :disabled="!dateRangePreset || dateRangePreset === 'yearly'"
                  clearable
                  label="Period"
              ></v-select>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-menu
                  ref="menu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="accrDateFromValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="Accreditation Date From"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    ref="accrDateFromValue"
                    v-model="accrDateFromValue"
                    no-title
                    placeholder="Accreditation Date From"
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-menu
                  ref="menu"
                  v-model="startMenu2"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="accrDateToValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="Accreditation Date To"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    ref="accrDateToValue"
                    v-model="accrDateToValue"
                    no-title
                    placeholder="Accreditation Date To"
                    scrollable
                    @input="startMenu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </template>
        <template v-slot:[`item.accreditorName`]="{ item }">
          <label for="item">{{
              item.accreditorName ? item.accreditorName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditationCode`]="{ item }">
          <label for="item">{{
              item.accreditationCode ? item.accreditationCode : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditorStatus`]="{ item }">
          <v-chip :color="getColor(item.accreditorStatus)" dark>
            <label for="item">{{
                item.accreditorStatus && item.accreditorStatus == true
                    ? "Active"
                    : "Not Active"
              }}</label>
          </v-chip>
        </template>
        <template v-slot:[`item.trainingCenterName`]="{ item }">
          <label for="item">{{
              item.trainingCenterName ? item.trainingCenterName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.cpdProviderStatus`]="{ item }">
          <v-chip :color="getColor(item.cpdProviderStatus)" dark>
            <label for="item">{{
                item.cpdProviderStatus && item.cpdProviderStatus == true
                    ? "Active"
                    : "Not Active"
              }}</label>
          </v-chip>
        </template>
        <template v-slot:[`item.accreditationDate`]="{ item }">
          <label for="item">{{
              item.accreditationDate ? item.accreditationDate : "-"
            }}</label>
        </template>
        <!-- <template v-slot:[`item.expertLevel`]="{ item }">
          <label for="item">{{
            item.expertLevel ? item.expertLevel.name : "-"
          }}</label>
        </template> -->
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {AccreditedCpdPService} from "./accredited-cpd-provider-service";
import reportDateRangeMixin from "@/mixins/reportDateRangeMixin";

export default {
  mixins: [reportDateRangeMixin],
  data() {
    return {
      accreditedCPDReports: [],
      headers: [

        {
          text: "CPD Provider's Name",
          value: "trainingCenterName",
          filter: (value) => {
            this.selected = [];
            if (this.cpdPNameValue == null || this.cpdPNameValue == "")
              return true;
            return value
                .toLowerCase()
                .includes(this.cpdPNameValue.toLowerCase());
          },
        },
        {text: "CPD Provider'S Status", value: "cpdProviderStatus"},
        {
          text: "CPD Provider's Accreditation Date",
          value: "accreditationDate",
          filter: (value) => {
            this.selected = [];
            const min = this.accrDateFromValue
                ? new Date(this.accrDateFromValue).getTime()
                : null;
            const max = this.accrDateToValue
                ? new Date(this.accrDateToValue).getTime()
                : null;
            const current = value ? new Date(value).getTime() : null;
            const validCurrent = current !== null && !Number.isNaN(current);
            if (!validCurrent) return true;
            if (min !== null && !Number.isNaN(min) && max === null) return min <= current;
            if (max !== null && !Number.isNaN(max) && min === null) return current <= max;
            if (min !== null && max !== null && !Number.isNaN(min) && !Number.isNaN(max)) {
              return min <= current && current <= max;
            }
            return true;
          },
        },

        {
          text: "Accreditor's Name",
          value: "accreditorName",
          filter: (value) => {
            this.selected = [];
            if (this.accreditorValue == null || this.accreditorValue == "")
              return true;
            return value
                .toLowerCase()
                .includes(this.accreditorValue.toLowerCase());
          },
        },
        {
          text: "Accreditation Code",
          value: "accreditationCode",
          filter: (value) => {
            this.selected = [];
            if (
                this.accreditationCodeValue == null ||
                this.accreditationCodeValue == ""
            )
              return true;
            return value
                .toLowerCase()
                .includes(this.accreditationCodeValue.toLowerCase());
          },
        },
        {text: "Accreditor's Status", value: "accreditorStatus"},

        // { text: "CPD Provider's Expert Level", value: "expertLevel.name" },
        // { text: "CPD Provider's Region", value: "woreda.name" },
        // { text: "CPD Provider's Zone", value: "woreda.name" },
        // { text: "CPD Provider's Woreda", value: "woreda.name" },
      ],
      selected: [],
      export_fields: {
        "CPD Provider's Name": "trainingCenterName",
        "CPD Provider'S Status": {
          field: "cpdProviderStatus",
          callback: (value) => {
            const resp = value !== null ? (value ? 'Active' : 'Not Active') : '-';
            return resp;
          }
        },
        "CPD Provider's Accreditation Date": "accreditationDate",
        // "Course Owner": "courseOwner.trainingCenterName",

        "Accreditor's Name": "accreditorName",
        "Accreditation Code": "accreditationCode",
        "Accreditor's Status": {
          field: "accreditorStatus",
          callback: (value) => {
            const resp = value !== null ? (value ? 'Active' : 'Not Active') : '-';
            return resp;
          }
        },

      },
      accreditorValue: null,
      accreditationCodeValue: null,
      cpdPNameValue: null,
      startMenu: false,
      startMenu2: false,
      accrDateFromValue: null,
      accrDateToValue: null,
      dateRangePreset: null,
      dateRangeYear: null,
      dateRangePeriod: null,
    };
  },
  async beforeMount() {
    this.fetchAccreditedCPDReports();
  },
  computed: {
    filteredReports() {
      const nameFilter = this.cpdPNameValue
          ? this.cpdPNameValue.toLowerCase()
          : null;
      const accreditorFilter = this.accreditorValue
          ? this.accreditorValue.toLowerCase()
          : null;
      const accreditationFilter = this.accreditationCodeValue
          ? this.accreditationCodeValue.toLowerCase()
          : null;
      const minDate = this.accrDateFromValue
          ? new Date(this.accrDateFromValue).getTime()
          : null;
      const maxDate = this.accrDateToValue
          ? new Date(this.accrDateToValue).getTime()
          : null;

      return (this.accreditedCPDReports || []).filter((item) => {
        if (nameFilter) {
          const value = (item.trainingCenterName || "").toLowerCase();
          if (!value.includes(nameFilter)) return false;
        }
        if (accreditorFilter) {
          const value = (item.accreditorName || "").toLowerCase();
          if (!value.includes(accreditorFilter)) return false;
        }
        if (accreditationFilter) {
          const value = (item.accreditationCode || "").toLowerCase();
          if (!value.includes(accreditationFilter)) return false;
        }
        if (minDate !== null || maxDate !== null) {
          const currentDate = item.accreditationDate
              ? new Date(item.accreditationDate).getTime()
              : null;
          if (currentDate === null || Number.isNaN(currentDate)) return false;
          if (minDate !== null && !Number.isNaN(minDate) && currentDate < minDate) return false;
          if (maxDate !== null && !Number.isNaN(maxDate) && currentDate > maxDate) return false;
        }
        return true;
      });
    },
  },
  watch: {
    dateRangePreset(val) {
      this.applyPresetWithSelection(val, "accrDateFromValue", "accrDateToValue", "dateRangeYear", "dateRangePeriod");
    },
    dateRangeYear() {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "accrDateFromValue", "accrDateToValue", "dateRangeYear", "dateRangePeriod");
      }
    },
    dateRangePeriod() {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "accrDateFromValue", "accrDateToValue", "dateRangeYear", "dateRangePeriod");
      }
    },
  },
  methods: {
    async fetchAccreditedCPDReports() {
      this.loading = true;
      const res = await AccreditedCpdPService.getAccreditedCpdPService();
      if (res.status === 200) {
        this.loading = false;
        this.accreditedCPDReports = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching accredited CPD Provider reports, Please try Again!"
        );
      }
    },
    getColor(isActive) {
      if (isActive == false) return "red";
      else return "green";
    },
  },
};
</script>
